export const SUPPORTED_EXTENSIONS = ["doc", "docx", "msg", "pdf", "rtf", "txt"];
export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
export const API_ENDPOINT = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const INFO_EMAIL = "info@canotera.com";
export const DEFAULT_CACHE_TTL_SECONDS = 30;
export const CACHE_ENABLED = false;
export const SUPPORTED_MIME_TYPES = [
  "text/plain",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-outlook",
];
export const MAX_POST_REQUEST_SIZE = 30 * 1024 * 1024; // 30 MB
export const ZIP_MIME_TYPES = ["application/zip", "application/x-zip-compressed"];
export const ZIP_EXTENSION = ".zip";
export const UNIFIED_UPLOAD_ENABLED = true;